const { VUE_APP_API, VUE_APP_VERSION, VUE_APP_RECAPTCHA_KEY } = process.env;

export const API_URL = VUE_APP_API;
export const VERSION = VUE_APP_VERSION;
export const TOKEN_RECAPTCHA = VUE_APP_RECAPTCHA_KEY;

export default {
  API_URL,
  VERSION,
  TOKEN_RECAPTCHA,
};
